import { UserBase } from './User';
import { Link } from './Link';

export interface VideoCallParticipant extends UserBase {
  links?: Link[];
}

export type VideoCall = {
  id: string;
  called: VideoCallParticipant;
  caller: VideoCallParticipant;
  command: {
    currentState: VideoCallState;
  };
  missingCallNotificationHasBeenSent?: boolean;
  participantType: VideoCallParticipantType;
  roomName: string;
};

export enum VideoCallState {
  Initial = 'Initial',
  WaitingNotificationAcknowledge = 'WaitingNotificationAcknowledge',
  NotificationAcknowledgeTimeout = 'NotificationAcknowledgeTimeout',
  NotificationAcknowledgeBusy = 'NotificationAcknowledgeBusy',
  WaitingCalledAnswer = 'WaitingCalledAnswer',
  CallRefused = 'CallRefused',
  CalledAnswerTimeout = 'CalledAnswerTimeout',
  WaitingCallStart = 'WaitingCallStart',
  CallStartTimeout = 'CallStartTimeout',
  Running = 'Running',
  Ended = 'Ended',
  Interrupted = 'Interrupted',
  EXIT_WITH_ERROR = 'EXIT_WITH_ERROR',
}

export enum VideoCallParticipantType {
  CALLED,
  CALLER,
}

export enum VideoCallDisabledReasonsType {
  MINIMAL_ANDROID_VERSION,
  MINIMAL_ARDOIZ_CORE_VERSION,
}